import { showToast } from 'stores/ToastStore';
import qs from 'qs';
import { t } from 'i18next';
import client from './rest/AdminClient';
const _getAllReasonCodes = (query) => {
    return client({
        method: 'GET',
        path: `/api/v2/shippers/reason-codes/defaults/?${qs.stringify(query)}`,
    });
};
const _getReasonCodesByQuery = (query) => {
    return client({
        method: 'GET',
        path: `/api/v2/shippers/reason-codes?${qs.stringify(query)}`,
    });
};
const _getDefaultReasonCodes = () => {
    const queryString = qs.stringify({
        default: true,
    });
    return client({
        method: 'GET',
        path: `/api/v2/shippers/reason-codes?${queryString}`,
    });
};
const _getReasonCodesByShipper = (id) => {
    const queryString = qs.stringify({
        shipper: id,
    });
    return client({
        method: 'GET',
        path: `/api/v2/shippers/reason-codes?${queryString}`,
    });
};
const _createReasonCodeCategory = (payload) => {
    return client({
        method: 'POST',
        path: `/api/v2/shippers/reason`,
        entity: JSON.stringify(payload),
    });
};
const _createReasonCode = (reasonId, payload) => {
    return client({
        method: 'POST',
        path: `/api/v2/shippers/reason/${reasonId}/reason-codes`,
        entity: JSON.stringify(payload),
    });
};
const _updateReasonCodeCategory = (id, payload) => {
    return client({
        method: 'PATCH',
        path: `/api/v2/shippers/reason/${id}`,
        entity: JSON.stringify(payload),
    });
};
const _updateReasonCode = (reasonId, id, payload) => {
    return client({
        method: 'PATCH',
        path: `/api/v2/shippers/reason/${reasonId}/reason-codes/${id}`,
        entity: JSON.stringify(payload),
    });
};
const _deleteReasonCodeCategory = (id) => {
    return client({
        method: 'DELETE',
        path: `/api/v2/shippers/reason/${id}`,
    });
};
const _deleteReasonCode = (reasonId, id) => {
    return client({
        method: 'DELETE',
        path: `/api/v2/shippers/reason/${reasonId}/reason-codes/${id}`,
    });
};
export const getAllReasonCodes = (query) => {
    return _getAllReasonCodes(query).then((response) => {
        const items = response.entity.result.items || [];
        return items;
    }, (error) => {
        showToast(t('SHIPPER_REASON_CODES_FETCH_FAILED'), '', 'error');
        throw error;
    });
};
export const getSortedReasonCodes = async (shipperId, shipment_type, category) => {
    if (!shipperId || !shipment_type || !category) {
        return null;
    }
    const lineOfBusiness = shipment_type === 'shorthaul' ||
        shipment_type === 'longhaul' ||
        shipment_type === 'dayrate'
        ? 'shorthaul'
        : 'drayage';
    try {
        const queryString = {
            shipper: shipperId,
            lineOfBusiness,
        };
        /* Get all reason codes
        - Searches for defaults
        - Searches for shipper specific codes
        - If we find shipper specific codes use those instead of defaults and require them as well
        */
        const res = await getAllReasonCodes(queryString);
        const defaultCodes = res.find((item) => item.default === true);
        if (!defaultCodes) {
            console.log('Error: Missing Default Reason Codes');
            return { subCategories: [], requireCodes: false };
        }
        const defaultCategories = defaultCodes.categories.find((c) => c.name === category);
        const shipperCodes = res.find((item) => item.shipper === shipperId);
        let shipperCategories = null;
        let requireCodes = false;
        if (shipperCodes && shipperCodes.categories) {
            shipperCategories = shipperCodes.categories.find((c) => c.name === category);
        }
        let subCategories = defaultCategories.subCategories;
        if (shipperCategories &&
            shipperCategories.subCategories &&
            shipperCategories.subCategories.length) {
            subCategories = shipperCategories.subCategories;
            requireCodes = true;
        }
        return { subCategories, requireCodes };
    }
    catch (e) {
        console.error('Error getting reason codes', e);
    }
};
export const getReasonCodesByQuery = (query) => {
    return _getReasonCodesByQuery(query).then((response) => {
        const items = response.entity.result.items || [];
        return items;
    }, (error) => {
        showToast(t('SHIPPER_REASON_CODES_FETCH_FAILED'), '', 'error');
        throw error;
    });
};
export const getDefaultReasonCodes = () => {
    return _getDefaultReasonCodes().then((response) => {
        console.log(response);
        const items = response.entity.result.items || [];
        return items;
    }, (error) => {
        showToast(t('SHIPPER_REASON_CODES_FETCH_FAILED'), '', 'error');
        throw error;
    });
};
export const getReasonCodesByShipper = async (id) => {
    return _getReasonCodesByShipper(id).then((response) => {
        const items = response.entity.result.items || [];
        return items;
    }, (error) => {
        showToast(t('SHIPPER_REASON_CODES_FETCH_FAILED'), '', 'error');
        throw error;
    });
};
export const getDeclinedAccessorialsReasonCodes = () => {
    return _getDefaultReasonCodes().then((response) => {
        const items = response.entity.result.items || [];
        try {
            const accessorialsReasonCodes = items
                .filter((i) => i.lineOfBusiness === 'drayage')[0]
                .categories.filter((c) => c.name === 'accessorials')[0]
                .subCategories.filter((sc) => sc.reasonType === 'Declined Accessorials')[0]
                .reasonCodes.map((c) => c.description);
            return accessorialsReasonCodes;
        }
        catch (error) {
            showToast(t('SHIPPER_REASON_CODES_FETCH_FAILED'), '', 'error');
            throw error;
        }
    }, (error) => {
        showToast(t('SHIPPER_REASON_CODES_FETCH_FAILED'), '', 'error');
        throw error;
    });
};
// Creates a reason code category
export const createReasonCodeCategory = (data) => {
    return _createReasonCodeCategory(data).then((response) => {
        showToast(t('REASON_CODE'), t('CREATED_REASON_CODE_CATEGORY'));
        return response.entity.result.items;
    }, (error) => {
        showToast(t('REASON_CODE_CREATION_FAILED'), '', 'error');
        throw error;
    });
};
// Creates an individual reason code
export const createReasonCode = (reasonId, data) => {
    return _createReasonCode(reasonId, data).then((response) => {
        showToast(t('REASON_CODE'), t('REASON_CODE_CREATED'));
        return response.entity.result.items;
    }, (error) => {
        showToast(t('REASON_CODE_CREATION_FAILED'), '', 'error');
        throw error;
    });
};
export const updateReasonCodeCategory = (id, updates) => {
    console.log('Updating API', updates, id);
    return _updateReasonCodeCategory(id, updates).then((response) => {
        showToast(t('REASON_CODE'), t('REASON_CODE_CATEGORY_UPDATED'));
        return response.entity.result.items;
    }, (error) => {
        showToast(t('REASON_CODE_UPDATION_FAILED'), '', 'error');
        throw error;
    });
};
export const updateReasonCode = (reasonId, id, updates) => {
    console.log('Updating API', updates, id);
    return _updateReasonCode(reasonId, id, updates).then((response) => {
        showToast(t('REASON_CODE'), t('REASON_CODE_UPDATED'));
        return response;
    }, (error) => {
        showToast(t('REASON_CODE_UPDATION_FAILED'), '', 'error');
        throw error;
    });
};
export const deleteReasonCodeCategory = (id) => {
    return _deleteReasonCodeCategory(id).then((response) => {
        showToast(t('REASON_CODE'), t('REASON_CODE_CATEGORY_DELETED'));
        return response;
    }, (error) => {
        showToast(t('REASON_CODE_DELETION_FAILED'), '', 'error');
        throw error;
    });
};
export const deleteReasonCode = (reasonId, id) => {
    return _deleteReasonCode(reasonId, id).then((response) => {
        showToast(t('REASON_CODE'), t('REASON_CODE_DELETED'));
        return response;
    }, (error) => {
        showToast(t('REASON_CODE_DELETION_FAILED'), '', 'error');
        throw error;
    });
};
